import React, { useEffect } from "react";
import img from "../../../Home/img_project/webp/4.webp";

const Block = ({ title, children }) => (
  <section className="pj-block">
    <h2>{title}</h2>
    <div className="pj-block-content">{children}</div>
  </section>
);

export default function ProjectSalonVIP() {

  useEffect(() => {
    document.title =
      "Salon VIP – Espace premium & plafond lumineux | UNIK SYSTEM";

    let meta = document.querySelector("meta[name='description']");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.setAttribute(
      "content",
      "Création d’un espace VIP premium avec plafond lumineux rétro-éclairé. Solution design et élégante pour espaces haut de gamme."
    );
  }, []);

  return (
    <div className="pj-page">

      {/* HERO */}
      <section className="pj-hero">
        <div className="pj-hero-text">
          <span className="pj-badge">PROJET RÉFÉRENCE</span>

          <h1>
            Salon VIP <br /> Espace premium & plafond lumineux
          </h1>

          <p>
            Création d’un espace VIP exclusif avec plafond lumineux
            rétro-éclairé, combinant design élégant et ambiance
            lumineuse haut de gamme.
          </p>

          <p className="pj-sub">
            Solutions UNIK SYSTEM : plafonds lumineux, rétroéclairage,
            design premium.
          </p>

          <div className="pj-hero-actions">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-projet-salon-vip.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche projet
            </a>
          </div>
        </div>

        <div className="pj-hero-img">
          <img src={img} alt="Salon VIP plafond lumineux" />
        </div>
      </section>

      {/* CONTEXTE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Contexte du projet</span>}>
        <p>
          Aménagement d’un salon VIP destiné à accueillir une clientèle
          haut de gamme dans un espace confortable et élégant.
        </p>
        <p>
          L’objectif était de créer une ambiance lumineuse premium
          avec un plafond rétro-éclairé, offrant une atmosphère
          chaleureuse et raffinée.
        </p>
      </Block>

      {/* SOLUTIONS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Solutions UNIK SYSTEM</span>}>
        <ul className="pj-list">
          <li>Plafond lumineux rétro-éclairé</li>
          <li>Intégration de systèmes LED</li>
          <li>Diffusion lumineuse homogène</li>
          <li>Structure aluminium technique</li>
          <li>Finition design haut de gamme</li>
        </ul>
      </Block>

      {/* RESULTATS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Résultats obtenus</span>}>
        <ul className="pj-list">
          <li>Ambiance lumineuse premium</li>
          <li>Expérience client améliorée</li>
          <li>Design moderne et élégant</li>
          <li>Confort visuel optimal</li>
          <li>Valorisation de l’espace VIP</li>
        </ul>
      </Block>

      {/* GALERIE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Galerie projet</span>}>
        <div className="pj-gallery">
          <img src={img} alt="" />
          <img src={img} alt="" />
          <img src={img} alt="" />
        </div>
      </Block>

      {/* CTA */}
      <section className="pj-cta">
        <h2>Vous avez un projet similaire ?</h2>
        <p>
          Notre équipe technique vous accompagne de la conception à la pose.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
